/**
 * PageFallback — local Suspense fallback for lazily-loaded route content.
 *
 * Rendered INSIDE the persistent Vanturis shell (Navbar/Footer stay mounted),
 * so a route-chunk fetch never produces a blank screen or full-app spinner.
 * Intentionally minimal: an ivory content area with a subtle copper pulse —
 * no "Loading…" text, no global teardown.
 */
export default function PageFallback() {
  return (
    <div
      className="min-h-[70vh] w-full bg-ivory flex items-center justify-center"
      aria-hidden="true"
      data-testid="page-fallback"
    >
      <div className="h-1 w-24 rounded-full bg-copper/30 animate-pulse" />
    </div>
  );
}
